export default "__VITE_ASSET__kiO0hMiS__"